/**
 * @desc 获取销售报价
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ListingQuoteRpcResponseDto>;
export function request(
  body: defs.basics.ListingQuoteRpcRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/getQuote`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
